module.exports = __webpack_public_path__ + "static/media/money.d1749735.svg";